
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/short-term-storage-services",
      function () {
        return require("private-next-pages/short-term-storage-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/short-term-storage-services"])
      });
    }
  